import '.bn{flex-shrink:0;}.ssr-plugin'
import '.im{width:7.625rem;}.ssr-plugin'
import '.in{background-size:cover;}.ssr-plugin'
import '.io{background-position:center;}.ssr-plugin'
import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { styled } from 'inlines'
import { InitiativeStatusRow } from './blocks/InitiativeStatusRow'
import { Text } from '@app/components/core/typography/Text'

export interface MiniCardProps {
  image: string
  location: string
  status?: string
  title: string
  description?: string
  onClick?: () => void
}

export const MiniCard = ({
  image,
  location,
  status,
  title,
  description,
  onClick,
}: MiniCardProps) => {
  return (
    <Row
      gap="0"
      onClick={onClick}
      style={{
        backgroundColor: 'var(--shades-white)',
        borderRadius: '1.25rem',
        overflow: 'hidden',
        cursor: onClick ? 'pointer' : 'default',
        flex: 1,
      }}
    >
      <div className="bn im in io"
        style={{
          backgroundImage: `url(${image})`,}}
      />

      <Column
        alignItems="stretch"
        style={{
          padding: '1rem',
          borderRadius: '0 1.25rem 1.25rem 0',
          border: 'var(--blue-border)',
          overflow: 'hidden',
          minWidth: 0,
        }}
      >
        <InitiativeStatusRow location={location} status={status} />
        <Column gap="0.5rem">
          <Title.H5
            style={{
              margin: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              width: '100%',
            }}
          >
            {title}
          </Title.H5>
          <Text.Small
            color="var(--shades-blue-300)"
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              width: '100%',
            }}
          >
            {description}
          </Text.Small>
        </Column>
      </Column>
    </Row>
  )
}
